import * as React from 'react'

function SvgHourglassCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11c0-.338.019-.672.055-1H12.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v2.877a5 5 0 0 0 3.787 4.85l1.09.273-1.09.272A5 5 0 0 0 13 25.123V28h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H27v-2.877a5 5 0 0 0-3.787-4.85L22.123 20l1.09-.272a4.99 4.99 0 0 0 1.635-.74 9.02 9.02 0 0 1-1.85-1.282 3.01 3.01 0 0 1-.27.081l-1.09.273c-2.02.505-2.02 3.375 0 3.88l1.09.273A3 3 0 0 1 25 25.123v.394c-.258-.11-.542-.232-.84-.366-1.243-.56-2.655-1.272-3.56-1.951l-.6-.45-.6.45c-.905.679-2.318 1.391-3.56 1.95-.298.135-.582.258-.84.367v-.394a3 3 0 0 1 2.272-2.91l1.09-.273c2.02-.505 2.02-3.375 0-3.88l-1.09-.273A3 3 0 0 1 15 14.877V12h5.055A9.098 9.098 0 0 1 20 11Zm-5 17v-.318l.03-.013c.416-.167.99-.407 1.63-.695 1.043-.469 2.312-1.09 3.34-1.757 1.027.667 2.297 1.288 3.34 1.757.64.288 1.214.528 1.63.695l.03.013V28H15Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgHourglassCheckedIcon
